import {
  buildGoogleAuthUrl,
  buildKakaoAuthUrl,
  LoginLogoSection,
  LoginTermsFooter,
  SocialLoginSection,
} from '@features/auth'

import { AppHeader } from '@shared/ui/app-header'
import { Footer } from '@shared/ui/footer'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login')({
  component: LoginPage,
  ssr: false,
})

function LoginPage() {
  return (
    <>
      <AppHeader
        leading={<AppHeader.BackLink to="/saju/$sajuType" params={{ sajuType: 'classic' }} />}
        variant="transparent"
      />

      <section className="flex flex-1 flex-col items-center justify-center px-6">
        <LoginLogoSection />
        <SocialLoginSection
          onKakaoLogin={() => {
            window.location.href = buildKakaoAuthUrl()
          }}
          onGoogleLogin={() => {
            window.location.href = buildGoogleAuthUrl()
          }}
        />
      </section>

      <LoginTermsFooter />
      <Footer />
    </>
  )
}
